import { Action } from "../../action";
import { Cursor } from "../../cursor";
import { MarshalParameters } from "../../marshal";

export class IncrementRegister extends Action
{
    public constructor()
    {
        super({
            description: "Set the key register to the value parameter plus the increment parameter",
            parameters: {
                key: {
                    description: "The register to receive the value",
                    type: "number"
                },
                value: {
                    description: "The value to be incremented",
                    type: "number"
                },
                increment: {
                    description: "The amount to increment by",
                    type: "number"
                }
            }
        });
    }
    Resolve(cursor: Cursor, parameters: MarshalParameters): boolean
    {
        const value = parameters.value.value(cursor) as number;
        const increment = parameters.increment.value(cursor) as number;

        cursor.setRegister(
            parameters.key.reference as string,
            value + increment);
        return true;
    }
}